<template>
  <div v-if="!isPrint">
    <p class="mb-4" style="color: #e42728">{{ $t("※ 사업주는 사망 또는 3일 이상 휴업이 필요한 산업재해 발생 시 발생한 날부터 1개월 이내에 지방고용노동관서(산재예방지도과)에 산업재해 조사표를 작성·제출해야 합니다.") }}</p>

    <!--    기본정보-->
    <field-select-module
      v-model="form.stdInfo"
      :options="[
        { type: 'text', label: '작성자 전화번호' },
        { type: 'alert', label: '알림 대상자 선택' },
      ]"
      :board="this.board"
      :is-print="isPrint"
      field-name="회사명(필수)"
    />

    <!-- 현장/사업장 정보 -->
    <vs-row class="mt-6">
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
        <h5><i class="dot"></i>{{ $t("사업장 정보") }}</h5>
      </vs-col>
    </vs-row>

    <div class="writeGridContainer mt-4">
      <div>
        <div>{{ $t("사업장명") }}</div>
        <p v-if="isPrint" class="print-input">{{ form.inputB_1 }}</p>
        <company-selector v-else :readonly="board.readonly || !form.stdInfo.field_id" v-model="form.inputB_1" class="w-full flex-1" :field-id="form.stdInfo.field_id" @select="onComapnySelect" />
      </div>

      <div>
        <div>{{ $t("산재관리번호") }}<br />({{ $t("사업개시번호") }})</div>
        <p v-if="isPrint" class="print-input">{{ form.inputB_2 }}</p>
        <ml-input v-else v-model="form.inputB_2" class="w-full flex-1" :readonly="board.readonly" />
      </div>

      <div>
        <div>{{ $t("사업자등록번호") }}</div>
        <p v-if="isPrint" class="print-input">{{ form.inputB_3 }}</p>
        <ml-input v-else v-model="form.inputB_3" class="w-full flex-1" :readonly="board.readonly" />
      </div>

      <div>
        <div>{{ $t("근로자 수(명)") }}</div>
        <p v-if="isPrint" class="print-input">{{ form.inputB_4 }}</p>
        <comma-input v-else v-model="form.inputB_4" class="w-full flex-1" type="number" :readonly="board.readonly" />
      </div>

      <div>
        <div>{{ $t("업종") }}</div>
        <p v-if="isPrint" class="print-input">{{ form.inputB_5 }}</p>
        <ml-input v-else v-model="form.inputB_5" class="w-full flex-1" :readonly="board.readonly" />
      </div>

      <div>
        <div>{{ $t("소재지") }}</div>
        <p v-if="isPrint" class="print-input">{{ form.inputB_6 }}</p>
        <ml-input v-else v-model="form.inputB_6" class="w-full flex-1" :readonly="board.readonly" />
      </div>
    </div>

    <!--    재해자 고용형태-->
    <vs-row class="mt-8">
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
        <h5><i class="dot"></i>{{ $t("재해자 고용형태") }}</h5>
      </vs-col>
    </vs-row>

    <div class="grid xl:grid-cols-12 gap-x-6 gap-y-4 mt-4">
      <div class="col-span-4 flex items-center" v-for="checkbox in typeCheckBox" v-bind:key="checkbox.id">
        <div v-if="isPrint" class="flex items-center">
          <div v-if="form.employmentType.includes(checkbox.id)" style="background: #200c63" class="w-5 h-5 rounded-sm text-white flex justify-center items-center mr-2">
            <vs-icon icon="check" size="x-small"></vs-icon>
          </div>
          <div v-else style="border: 1px solid #200c63" class="w-5 h-5 rounded-sm text-white flex justify-center items-center mr-2">
            <vs-icon icon="check" size="x-small"></vs-icon>
          </div>
          {{ $t(checkbox.label) }}
        </div>
        <label v-else class="flex">
          <vs-checkbox :vs-value="checkbox.id" :disabled="board.readonly" v-model="form.employmentType" @change="onCheck($event)"> </vs-checkbox>
          {{ $t(checkbox.label) }}
        </label>
      </div>
    </div>

    <!-- 분기 -->
    <div>
      <vs-row class="mt-8" v-if="form.list && form.list.length !== 0">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
          <h5><i class="dot"></i> {{ $t(form.employmentTypeLabel) }}</h5>
        </vs-col>
      </vs-row>

      <div class="print-container grid grid-cols-12 gap-x-6 gap-y-4 mt-4" v-if="form.list && form.list.length !== 0">
        <div class="flex items-center" :class="isMobile ? 'col-span-12' : 'col-span-4'" v-for="(data, data_i) in form.list" :key="`${form.employmentTypeLabel}_${data_i}`">
          <div class="label-text mr-4">{{ $t(data.text) }}</div>
          <p v-if="isPrint" class="print-input">{{ data.value }}</p>
          <div v-else class="w-full flex-1">
            <vs-select :disabled="board.readonly" v-if="data.type === 'select'" v-model="data.value" autocomplete class="w-full flex-1">
              <vs-select-item :text="$t('민간')" value="민간" />
              <vs-select-item :text="$t('국가·지방자치단체')" value="국가·지방자치단체" />
              <vs-select-item :text="$t('공공기관')" value="공공기관" />
            </vs-select>
            <div v-else class="w-full flex items-center gap-2">
              <ml-input v-model="data.value" class="w-full flex-1" :readonly="board.readonly" />
              <p v-if="!!data.afterText">{{ $t(data.afterText) }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--    재해정보-->
    <div>
      <vs-row class="mt-6">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
          <h5><i class="dot"></i>{{ $t("재해정보") }}</h5>
        </vs-col>
      </vs-row>

      <div class="writeGridContainer mt-4">
        <div>
          <div>{{ $t("성명") }}</div>
          <p v-if="isPrint" class="print-input">{{ form.inputC_1 }}</p>
          <ml-input v-else v-model="form.inputC_1" class="w-full flex-1" :readonly="board.readonly" />
        </div>

        <div>
          <div>{{ $t("주민등록번호") }}<br />({{ $t("외국인등록번호") }})</div>
          <p v-if="isPrint" class="print-input">{{ form.enc.inputC_2 }}</p>
          <resident-number-input v-else v-model="form.enc.inputC_2" class="w-full flex-1" :readonly="board.readonly" :is-print="isPrint" />
        </div>

        <div>
          <!--          <div>{{ $t("성별") }}</div>-->
          <!--          <p v-if="isPrint" class="print-input">{{ form.inputC_3 }}</p>-->
          <!--          <div v-else class="w-full flex-1 flex gap-x-8 gap-y-4">-->
          <!--            <vs-radio v-model="form.inputC_3" :disabled="board.readonly" vs-name="gender" vs-value="남">{{ $t("남") }}</vs-radio>-->
          <!--            <vs-radio v-model="form.inputC_3" :disabled="board.readonly" vs-name="gender" vs-value="여">{{ $t("여") }}</vs-radio>-->
          <!--          </div>-->
        </div>

        <div>
          <div>{{ $t("주소") }}</div>
          <p v-if="isPrint" class="print-input">{{ form.enc.inputC_20 }}</p>
          <ml-input v-else v-model="form.enc.inputC_20" class="w-full flex-1" :readonly="board.readonly" />
        </div>

        <div>
          <div>{{ $t("휴대전화") }}</div>
          <p v-if="isPrint" class="print-input">{{ form.enc.inputC_5 }}</p>
          <hyphen-input v-else v-model="form.enc.inputC_5" class="w-full flex-1" :readonly="board.readonly" />
          <!--          <ml-input v-else v-model="form.inputC_5" class="w-full flex-1" :readonly="board.readonly" />-->
        </div>

        <div>
          <div>{{ $t("국적") }}</div>
          <p v-if="isPrint" class="print-input">{{ form.inputC_6 }}</p>
          <div v-else class="w-full flex-1 flex gap-x-8 gap-y-4">
            <vs-radio v-model="form.inputC_6" :disabled="board.readonly" vs-name="nationality" vs-value="내국인">{{ $t("내국인") }}</vs-radio>
            <vs-radio v-model="form.inputC_6" :disabled="board.readonly" vs-name="nationality" vs-value="외국인">{{ $t("외국인") }}</vs-radio>
          </div>
        </div>

        <div v-if="form.inputC_6 === '외국인'">
          <div>{{ $t("국적명") }}</div>
          <p v-if="isPrint" class="print-input">{{ form.inputC_7 }}</p>
          <ml-input v-else v-model="form.inputC_7" class="w-full flex-1" :readonly="board.readonly" />
        </div>

        <div>
          <div>{{ $t("직업") }}</div>
          <p v-if="isPrint" class="print-input">{{ form.inputC_4 }}</p>
          <ml-input v-else v-model="form.inputC_4" class="w-full flex-1" :readonly="board.readonly" />
        </div>

        <div v-if="form.inputC_6 === '외국인'">
          <div>{{ $t("체류자격") }}</div>
          <p v-if="isPrint" class="print-input">{{ form.inputC_8 }}</p>
          <ml-input v-else v-model="form.inputC_8" class="w-full flex-1" :readonly="board.readonly" />
        </div>

        <div>
          <div>{{ $t("입사일") }}</div>
          <p v-if="isPrint" class="print-input">{{ form.inputC_9 }}</p>
          <date-selector v-else class="w-full flex-1" v-model="form.inputC_9" :readonly="board.readonly" />
        </div>

        <div>
          <div>{{ $t("같은 종류업무 근속기간") }}</div>
          <p v-if="isPrint" class="print-input">{{ form.inputC_10 }} ~ {{ form.inputC_11 }}</p>
          <div v-else class="w-full flex flex-1 items-center grid grid-cols-12">
            <div class="col-span-6 flex items-center">
              <ml-input class="w-full" v-model="form.inputC_10" :readonly="board.readonly" />
              <p class="ml-2 mr-2 text-center">{{ $t("년") }}</p>
            </div>
            <div class="col-span-6 flex items-center">
              <ml-input class="w-full" v-model="form.inputC_11" :readonly="board.readonly" />
              <p class="ml-2 text-center">{{ $t("월") }}</p>
            </div>
          </div>
        </div>

        <div>
          <div>{{ $t("고용형태") }}</div>
          <p v-if="isPrint" class="print-input">{{ form.inputC_12 }}</p>
          <vs-select :disabled="board.readonly" v-else v-model="form.inputC_12" autocomplete class="w-full flex-1">
            <vs-select-item :text="$t('상용')" value="상용" />
            <vs-select-item :text="$t('임시')" value="임시" />
            <vs-select-item :text="$t('일용')" value="일용" />
            <vs-select-item :text="$t('무급가족종사자')" value="무급가족종사자" />
            <vs-select-item :text="$t('자영업자')" value="자영업자" />
            <vs-select-item :text="$t('그 밖의 사항')" value="그 밖의 사항" />
          </vs-select>
        </div>

        <div v-if="form.inputC_12 === '그 밖의 사항'">
          <div>{{ $t("(고용형태)") }}<br />{{ $t("그 밖의 사항") }}</div>
          <p v-if="isPrint" class="print-input">{{ form.inputC_13 }}</p>
          <ml-input v-else v-model="form.inputC_13" class="w-full flex-1" :readonly="board.readonly" />
        </div>

        <div>
          <div>{{ $t("근무형태") }}</div>
          <p v-if="isPrint" class="print-input">{{ form.inputC_14 }}</p>
          <vs-select :disabled="board.readonly" v-else v-model="form.inputC_14" autocomplete class="w-full flex-1">
            <vs-select-item :text="$t('정상')" value="정상" />
            <vs-select-item :text="$t('2교대')" value="2교대" />
            <vs-select-item :text="$t('3교대')" value="3교대" />
            <vs-select-item :text="$t('4교대')" value="4교대" />
            <vs-select-item :text="$t('시간제')" value="시간제" />
            <vs-select-item :text="$t('그 밖의 사항')" value="그 밖의 사항" />
          </vs-select>
        </div>

        <div v-if="form.inputC_14 === '그 밖의 사항'">
          <div>{{ $t("(근무형태)") }}<br />{{ $t("그 밖의 사항") }}</div>
          <p v-if="isPrint" class="print-input">{{ form.inputC_15 }}</p>
          <ml-input v-else v-model="form.inputC_15" class="w-full flex-1" :readonly="board.readonly" />
        </div>

        <div>
          <div>{{ $t("상해종류(질병명)") }}</div>
          <p v-if="isPrint" class="print-input">{{ form.inputC_16 }}</p>
          <ml-input v-else v-model="form.inputC_16" class="w-full flex-1" :readonly="board.readonly" />
        </div>

        <div>
          <div>{{ $t("상해부위(질병부위)") }}</div>
          <p v-if="isPrint" class="print-input">{{ form.inputC_17 }}</p>
          <ml-input v-else v-model="form.inputC_17" class="w-full flex-1" :readonly="board.readonly" />
        </div>

        <div>
          <div>{{ $t("휴업예상 일수") }}</div>
          <div class="flex items-center">
            <p v-if="isPrint" class="print-input">{{ form.inputC_18 }}</p>
            <comma-input v-else v-model="form.inputC_18" class="w-full flex-1" :readonly="board.readonly" />
            <p class="ml-2 text-center">{{ $t("일") }}</p>
          </div>
        </div>

        <div>
          <div>{{ $t("사망 여부") }}</div>
          <p v-if="isPrint" class="print-input">{{ form.inputC_19 }}</p>
          <vs-checkbox v-else :disabled="board.readonly" v-model="form.inputC_19" autocomplete class="w-full flex-1">{{ $t("사망") }}</vs-checkbox>
        </div>
      </div>
    </div>

    <!--    재해발생 개요 및 원인-->
    <div>
      <vs-row class="mt-6">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
          <h5><i class="dot"></i>{{ $t("재해발생 개요 및 원인") }}</h5>
        </vs-col>
      </vs-row>

      <div class="writeGridContainer mt-4">
        <div>
          <div>{{ $t("발생날짜") }}</div>
          <p v-if="isPrint" class="print-input">{{ form.inputD_1 }}</p>
          <date-selector v-else class="w-full flex-1" v-model="form.inputD_1" :readonly="board.readonly" />
        </div>

        <div>
          <div>{{ $t("발생시간") }}</div>
          <p v-if="isPrint" class="print-input">{{ form.inputD_2 }}</p>
          <time-selector v-else class="w-full flex-1" v-model="form.inputD_2" :readonly="board.readonly" />
        </div>

        <div>
          <div>{{ $t("발생장소") }}</div>
          <p v-if="isPrint" class="print-input">{{ form.inputD_3 }}</p>
          <ml-input v-else v-model="form.inputD_3" class="w-full flex-1" :readonly="board.readonly" />
        </div>

        <div>
          <div>{{ $t("재해형태(필수)") }}</div>
          <p v-if="isPrint" class="print-input">{{ form.inputD_5 }}</p>
          <disaster-class-selector v-else class="w-full flex-1" v-model="form.inputD_5" :readonly="board.readonly" />
        </div>

        <div>
          <div>{{ $t("재해관련 작업유형") }}</div>
          <div v-if="isPrint" class="print-textarea">{{ form.inputD_4 }}</div>
          <ml-textarea v-else class="flex-1 w-full" rows="5" v-model="form.inputD_4" :readonly="board.readonly" />
        </div>

        <div>
          <div>{{ $t("재해발생 당시상황") }}</div>
          <div v-if="isPrint" class="print-textarea">{{ form.inputD_6 }}</div>
          <ml-textarea v-else class="flex-1 w-full" rows="5" v-model="form.inputD_6" :readonly="board.readonly" />
        </div>

        <div>
          <div>{{ $t("재해발생 원인") }}</div>
          <div v-if="isPrint" class="print-textarea">{{ form.inputD_7 }}</div>
          <ml-textarea v-else class="flex-1 w-full" rows="5" v-model="form.inputD_7" :readonly="board.readonly" />
        </div>
      </div>
    </div>

    <!-- 재발방지계획 -->
    <div>
      <vs-row class="mt-6">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
          <h5><i class="dot"></i>{{ $t("재발방지계획") }}</h5>
        </vs-col>
      </vs-row>

      <div class="writeGridContainer mt-4">
        <div class="writeGridLineItem">
          <div>{{ $t("계획내용") }}</div>
          <div v-if="isPrint" class="print-textarea">{{ form.inputE_1 }}</div>
          <ml-textarea v-else class="w-full" rows="5" v-model="form.inputE_1" :readonly="board.readonly" />
        </div>
      </div>

      <!-- ========== PC ========== -->
      <div class="hidden md:block">
        <table class="table-1">
          <colgroup>
            <col width="30" />
            <col />
            <col width="350" />
          </colgroup>
          <tr>
            <td style="vertical-align: top">※</td>
            <td>
              {{ $t("위 재발방지 계획 이행을 위한 안전보건교육 및 기술지도 등을 한국산업안전보건공단에서 무료로 제공하고 있으니 즉시 기술지원 서비스를 받고자 하는 경우 오른쪽에 √ 표시를 하시기 바랍니다.") }}
            </td>
            <td>
              <label class="flex items-center cursor-pointer">
                <span>{{ $t("즉시 기술지원 서비스 요청") }}</span>
                <vs-checkbox v-model="form.inputE_2" :readonly="board.readonly"></vs-checkbox>
              </label>
            </td>
          </tr>
          <tr>
            <td style="vertical-align: top">※</td>
            <td>
              {{ $t("근로복지공단은 재해자의 개인정보를 활용하는 것에 동의하는 사람에 한정하여 해당 재해자에게 산재보험급여의 신청방법을 안내하고 있으니 관련 안내를 받으려는 재해자는 오른쪽에 √ 표시를 하시기 바랍니다.") }}
            </td>
            <td>
              <label class="flex items-center cursor-pointer">
                <span>{{ $t("산재보험급여 신청방법 안내를 위한 재해자의 개인정보 활용 동의") }}</span>
                <vs-checkbox v-model="form.inputE_5" :readonly="board.readonly"></vs-checkbox>
              </label>
            </td>
          </tr>
        </table>
      </div>
      <!-- ========== 모바일 ========== -->
      <div class="block md:hidden">
        <table class="table-1 table-1-mb">
          <colgroup>
            <col width="30" />
            <col />
          </colgroup>
          <tr>
            <td style="vertical-align: top">※</td>
            <td>
              {{ $t("위 재발방지 계획 이행을 위한 안전보건교육 및 기술지도 등을 한국산업안전보건공단에서 무료로 제공하고 있으니 즉시 기술지원 서비스를 받고자 하는 경우 오른쪽에 √ 표시를 하시기 바랍니다.") }}
            </td>
          </tr>
          <tr>
            <td style="vertical-align: top"></td>
            <td>
              <label class="flex justify-end items-center cursor-pointer mt-2">
                <span class="text-right">{{ $t("즉시 기술지원 서비스 요청") }}</span>
                <vs-checkbox v-model="form.inputE_2" :readonly="board.readonly"></vs-checkbox>
              </label>
            </td>
          </tr>
          <tr>
            <td style="vertical-align: top">※</td>
            <td>
              {{ $t("근로복지공단은 재해자의 개인정보를 활용하는 것에 동의하는 사람에 한정하여 해당 재해자에게 산재보험급여의 신청방법을 안내하고 있으니 관련 안내를 받으려는 재해자는 오른쪽에 √ 표시를 하시기 바랍니다.") }}
            </td>
          </tr>
          <tr>
            <td style="vertical-align: top"></td>
            <td>
              <label class="flex justify-end items-center cursor-pointer mt-2">
                <span class="text-right">{{ $t("산재보험급여 신청방법 안내를 위한 재해자의 개인정보 활용 동의") }}</span>
                <vs-checkbox v-model="form.inputE_5" :readonly="board.readonly"></vs-checkbox>
              </label>
            </td>
          </tr>
        </table>
      </div>

      <div class="writeGridContainer mt-4">
        <div>
          <div>{{ $t("사업주") }}</div>
          <p v-if="isPrint" class="print-input">{{ form.inputE_3 }}</p>
          <ml-input v-else v-model="form.inputE_3" class="w-full flex-1" :readonly="board.readonly" />
        </div>
        <div>
          <div>{{ $t("근로자대표(재해자)") }}</div>
          <p v-if="isPrint" class="print-input">{{ form.inputE_4 }}</p>
          <ml-input v-else v-model="form.inputE_4" class="w-full flex-1" :readonly="board.readonly" />
        </div>
      </div>

      <table class="table-1 my-4">
        <tr>
          <td class="p-4">
            <div class="flex justify-end items-center">
              <ml-input v-model="form.inputE_6" :readonly="board.readonly" />
              <span class="mx-2">{{ $t("지방고용노동청장(지청장)") }}</span>
            </div>
          </td>
        </tr>
      </table>
    </div>

    <!-- ========== 처리절차  ========== -->
    <table class="table-1">
      <tr>
        <th class="text-center bold">{{ $t("처리절차") }}</th>
      </tr>
      <tr>
        <td class="text-center py-4 md:py-0">
          <div class="process-step flex-col md:flex-row">
            <div>
              <span class="square">{{ $t("신청서 작성") }}</span>
              <p style="font-size: 10px">{{ $t("신청인") }}</p>
            </div>
            <div class="arrow hidden md:block">→</div>
            <div class="arrow block md:hidden p-0 my-2">↓</div>
            <div>
              <span class="square">{{ $t("접수") }}</span>
              <p style="font-size: 10px">{{ $t("문서 접수 담당부서") }}</p>
            </div>
            <div class="arrow hidden md:block">→</div>
            <div class="arrow block md:hidden p-0 my-2">↓</div>

            <div>
              <span class="square">{{ $t("확인ㆍ검토") }}</span>
              <p style="font-size: 10px">{{ $t("산업안전ㆍ보건업무 담당부서") }}</p>
            </div>
            <div class="arrow hidden md:block">→</div>
            <div class="arrow block md:hidden p-0 my-2">↓</div>
            <div>
              <span class="square">{{ $t("결 재") }}</span>
              <p style="font-size: 10px">{{ $t("지방고용노동청(지청)장") }}</p>
            </div>
          </div>
        </td>
      </tr>
    </table>

    <table class="table-1 mt-8">
      <tr>
        <td class="pl-0" :style="methodActive ? 'border-bottom : none' : ''">
          <div class="w-full flex justify-between items-center" @click="onClickWM">
            <span class="pt-3 pb-3" style="font-size: 16px; font-weight: 500">{{ $t("작성방법") }}</span>
            <feather-icon icon="ChevronDownIcon" style="width: 14px; padding: 0 10px" class="transition duration-150 box-content cursor-pointer" :style="{ transform: methodActive ? `rotate(-180deg)` : `rotate(0deg)` }" />
          </div>
        </td>
      </tr>
      <tr v-show="methodActive">
        <td style="border-top: none">
          <p class="bold">{{ $t("Ⅰ. 사업장 정보") }}</p>
          <p>
            {{
              $t(
                "①산재관리번호(사업개시번호): 근로복지공단에 산업재해보상보험 가입이 되어 있으면 그 가입번호를 적고 사업장등록번호 기입란에는 국세청의 사업자등록번호를 적습니다. 다만, 근로복지공단의 산업재해보상보험에 가입이 되어 있지 않은 경우 사업자등록번호만 적습니다."
              )
            }}
          </p>
          <p>{{ $t("※ 산재보험 일괄 적용 사업장은 산재관리번호와 사업개시번호를 모두 적습니다.") }}</p>
          <p>
            {{
              $t(
                "②사업장명 : 재해자가 사업주와 근로계약을 체결하여 실제로 급여를 받는 사업장명을 적습니다. 파견근로자가 재해를 입은 경우에는 실제적으로 지휘ㆍ명령을 받는 사용사업주의 사업장명을 적습니다. [예: 아파트를 건설하는 종합건설업의 하수급 사업장 소속 근로자가 작업 중 재해를 입은 경우 재해자가 실제로 하수급 사업장의 사업주와 근로계약을 체결하였다면 하수급 사업장명을 적습니다.]"
              )
            }}
          </p>
          <p>{{ $t("③근로자 수: 사업장의 최근 근로자 수를 적습니다(정규직, 일용직ㆍ임시직 근로자, 훈련생 등 포함).") }}</p>
          <p>
            {{
              $t("④업종: 통계청(www.kostat.go.kr)의 통계분류 항목에서 한국표준산업분류를 참조하여 세세분류(5자리)를 적습니다. 다만, 한국표준산업분류 세세분류를 알 수 없는 경우 아래와 같이 한국표준산업명과 주요 생산품을 추가로 적습니다.")
            }}
          </p>
          <p>{{ $t("[예: 제철업, 시멘트제조업, 아파트건설업, 공작기계도매업, 일반화물자동차 운송업, 중식음식점업, 건축물 일반청소업 등 ]") }}</p>
          <p>{{ $t("⑤재해자가 사내 수급인 소속인 경우(건설업 제외): 원도급인 사업장명과 산재관리번호(사업개시번호)를 적습니다.") }}</p>
          <p>{{ $t("※ 원도급인 사업장이 산재보험 일괄 적용 사업장인 경우에는 원도급인 사업장 산재관리번호와 사업개시번호를 모두 적습니다.") }}</p>
          <p>{{ $t("⑥재해자가 파견근로자인 경우: 파견사업주의 사업장명과 산재관리번호(사업개시번호)를 적습니다.") }}</p>
          <p>{{ $t("※ 파견사업주의 사업장이 산재보험 일괄 적용 사업장인 경우에는 파견사업주의 사업장 산재관리번호와 사업개시번호를 모두 적습니다.") }}</p>
          <p>{{ $t("⑦원수급 사업장명: 재해자가 소속되거나 관리되고 있는 사업장이 하수급 사업장인 경우에만 적습니다.") }}</p>
          <p>{{ $t("⑧원수급 사업장 산재관리번호(사업개시번호): 원수급 사업장이 산재보험 일괄 적용 사업장인 경우에는 원수급 사업장 산재관리번호와 사업개시번호를 모두 적습니다.") }}</p>
          <p>{{ $t("⑨공사 종류, 공정률, 공사금액 : 수급 받은 단위공사에 대한 현황이 아닌 원수급 사업장의 공사 현황을 적습니다.") }}</p>
          <p>{{ $t("가. 공사 종류: 재해 당시 진행 중인 공사 종류를 말합니다. [예: 아파트, 연립주택, 상가, 도로, 공장, 댐, 플랜트시설, 전기공사 등]") }}</p>
          <p>{{ $t("나. 공정률: 재해 당시 건설 현장의 공사 진척도로 전체 공정률을 적습니다.(단위공정률이 아님)") }}</p>

          <p class="mt-8 bold">{{ $t("Ⅱ. 재해자 정보") }}</p>
          <p>{{ $t("⑩체류자격: 「출입국관리법 시행령」 별표 1에 따른 체류자격(기호)을 적습니다.(예: E-1, E-7, E-9 등)") }}</p>
          <p>
            {{
              $t(
                "⑪직업: 통계청(www.kostat.go.kr)의 통계분류 항목에서 한국표준직업분류를 참조하여 세세분류(5자리)를 적습니다. 다만, 한국표준직업분류 세세분류를 알 수 없는 경우 알고 있는 직업명을 적고, 재해자가 평소 수행하는 주요 업무내용 및 직위를 추가로 적습니다."
              )
            }}
          </p>
          <p>{{ $t("[예: 토목감리기술자, 전문간호사, 인사 및 노무사무원, 한식조리사, 철근공, 미장공, 프레스조작원, 선반기조작원, 시내버스 운전원, 건물내부청소원 등]") }}</p>
          <p>{{ $t("⑫같은 종류 업무 근속기간: 과거 다른 회사의 경력부터 현직 경력(동일ㆍ유사  업무 근무경력)까지 합하여 적습니다.(질병의 경우 관련 작업근무기간)") }}</p>
          <p>{{ $t("⑬고용형태: 근로자가 사업장 또는 타인과 명시적 또는 내재적으로 체결한 고용계약 형태를 적습니다.") }}</p>
          <p>{{ $t("가. 상용: 고용계약기간을 정하지 않았거나 고용계약기간이 1년 이상인 사람") }}</p>
          <p>{{ $t("나. 임시: 고용계약기간을 정하여 고용된 사람으로서 고용계약기간이 1개월 이상 1년 미만인 사람") }}</p>
          <p>{{ $t("다. 일용: 고용계약기간이 1개월 미만인 사람 또는 매일 고용되어 근로의 대가로 일급 또는 일당제 급여를 받고 일하는 사람") }}</p>
          <p>{{ $t("라. 자영업자: 혼자 또는 그 동업자로서 근로자를 고용하지 않은 사람") }}</p>
          <p>{{ $t("마. 무급가족종사자: 사업주의 가족으로 임금을 받지 않는 사람") }}</p>
          <p>{{ $t("바. 그 밖의 사항: 교육ㆍ훈련생 등") }}</p>
          <p>{{ $t("⑭근무형태  : 평소 근로자의 작업 수행시간 등 업무를 수행하는 형태를 적습니다.") }}</p>
          <p>{{ $t("가. 정상: 사업장의 정규 업무 개시시각과 종료시각(통상 오전 9시 전후에 출근하여 오후 6시 전후에 퇴근하는 것) 사이에 업무수행하는 것을 말합니다.") }}</p>
          <p>{{ $t("나. 2교대, 3교대, 4교대: 격일제근무, 같은 작업에 2개조, 3개조, 4개조로 순환하면서 업무수행하는 것을 말합니다.") }}</p>
          <p>{{ $t("다. 시간제 : 가목의 ‘정상’ 근무형태에서 규정하고 있는 주당 근무시간보다 짧은 근로시간 동안 업무수행하는 것을 말합니다.") }}</p>
          <p>{{ $t("라. 그 밖의 사항: 고정적인 심야(야간)근무 등을 말합니다.") }}</p>
          <p>{{ $t("⑮상해종류(질병명): 재해로 발생된 신체적 특성 또는 상해 형태를 적습니다.") }}</p>
          <p>{{ $t("[예: 골절, 절단, 타박상, 찰과상, 중독ㆍ질식, 화상, 감전, 뇌진탕, 고혈압, 뇌졸중, 피부염, 진폐, 수근관증후군 등]") }}</p>
          <p>{{ $t("⑯상해부위(질병부위): 재해로 피해가 발생된 신체 부위를 적습니다.") }}</p>
          <p>{{ $t("[예: 머리, 눈, 목, 어깨, 팔, 손, 손가락, 등, 척추, 몸통, 다리, 발, 발가락, 전신, 신체내부기관(소화ㆍ신경ㆍ순환ㆍ호흡배설) 등]") }}</p>
          <p>{{ $t("※ 상해종류 및 상해부위가 둘 이상이면 상해 정도가 심한 것부터 적습니다.") }}</p>
          <p>{{ $t("⑰휴업예상일수: 재해발생일을 제외한 3일 이상의 결근 등으로 회사에 출근하지 못한 일수를 적습니다.(추정 시 의사의 진단 소견을 참조)") }}</p>

          <p class="mt-8 bold">{{ $t("Ⅲ. 재해발생정보") }}</p>
          <p>
            {{
              $t(
                "⑱재해발생 개요:  재해원인의 상세한 분석이 가능하도록 발생일시[년, 월, 일, 요일, 시(24시 기준), 분], 발생 장소(공정 포함), 재해관련 작업유형(누가 어떤 기계ㆍ설비를 다루면서 무슨 작업을 하고 있었는지), 재해발생 당시 상황[재해 발생 당시 기계ㆍ설비ㆍ구조물이나 작업환경 등의 불안전한 상태(예시: 떨어짐, 무너짐 등)와 재해자나 동료 근로자가 어떠한 불안전한 행동(예시: 넘어짐, 까임 등)을 했는지]을 상세히 적습니다."
              )
            }}
          </p>
          <p>{{ $t("[작성예시]") }}</p>
          <div>
            <table class="table-2 mt-1">
              <colgroup>
                <col width="238" />
                <col />
              </colgroup>
              <tr>
                <th>{{ $t("발생일시") }}</th>
                <td>{{ $t("2013년 5월 30일 금요일 14시 30분") }}</td>
              </tr>
              <tr>
                <th>{{ $t("안전관계자인건비") }}</th>
                <td>{{ $t("사출성형부 플라스틱 용기 생산 1팀 사출공정에서") }}</td>
              </tr>
              <tr>
                <th>{{ $t("재해관련 작업유형") }}</th>
                <td>{{ $t("재해자 000가 사출성형기 2호기에서 플라스틱 용기를 꺼낸 후 금형을 점검하던 중") }}</td>
              </tr>
              <tr>
                <th>{{ $t("재해발생 당시 상황") }}</th>
                <td>{{ $t("재해자가 점검중임을 모르던 동료 근로자 000가 사출성형기 조작 스위치를 가동하여 금형 사이에 재해자가 끼어 사망하였음") }}</td>
              </tr>
            </table>
          </div>

          <p class="mt-1">
            {{
              $t(
                "⑲재해발생 원인: 재해가 발생한 사업장에서 재해발생 원인을 인적 요인(무의식 행동, 착오, 피로, 연령, 커뮤니케이션 등), 설비적 요인(기계ㆍ설비의 설계상 결함, 방호장치의 불량, 작업표준화의 부족, 점검ㆍ정비의 부족 등), 작업ㆍ환경적 요인(작업정보의 부적절, 작업자세ㆍ동작의 결함, 작업방법의 부적절, 작업환경 조건의 불량 등), 관리적 요인(관리조직의 결함, 규정ㆍ매뉴얼의 불비ㆍ불철저, 안전교육의 부족, 지도감독의 부족 등)을 적습니다."
              )
            }}
          </p>

          <p class="mt-8 bold">{{ $t("Ⅳ. 재발방지계획") }}</p>
          <p class="mb-4">{{ $t('⑳ "19. 재해발생 원인"을 토대로 재발방지 계획을 적습니다.') }}</p>
        </td>
      </tr>
    </table>

    <!--    파일첨부-->
    <file-upload-module id="fileList" class="w-full mt-4" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
  <Print v-else :form="form" />
</template>

<script>
import PopupPlanProject from "@/views/project/popup/PopupPlanProject";
import DateSelector from "@/components/selector/DateSelector";
import PopupProjectSetting from "@/views/project/PopupProjectSetting";
import MemberSelector from "@/components/selector/MemberSelector";
import CompanySelector from "@/components/selector/CompanySelector";
import FileUploader from "@/components/FileUploader";
import DisasterClassSelector from "@/components/selector/DisasterClassSelector";
import TimeSelector from "@/components/selector/TimeSelector";
import FileUploadModule from "@/views/modules/FileUploadModule";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import Print from "./Print.vue";
import ResidentNumberInput from "@/components/ResidentNumberInput.vue";

export default {
  components: {
    ResidentNumberInput,
    FieldSelectModule,
    FileUploadModule,
    TimeSelector,
    DisasterClassSelector,
    FileUploader,
    CompanySelector,
    MemberSelector,
    PopupProjectSetting,
    DateSelector,
    PopupPlanProject,
    Print,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  validations: {},
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value.summary = {
          중대재해발생_사업장명: [],
          중대재해발생_재해형태: [],
        };

        if (this.form.stdInfo) {
          value.summary["중대재해발생_사업장명"].push({
            [this.form.stdInfo.field_name]: 1,
          });
        }

        value.summary["중대재해발생_재해형태"].push({
          [this.form.inputD_5]: 1,
        });

        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      isMobile: false,
      methodActive: false,

      form: {
        stdInfo: {},
        enc: {
          inputC_2: "",
          inputC_5: "",
          inputC_20: "",
        },
        employmentType: [],
        employmentTypeLabel: "",
        inputA_1: "",
        inputA_2: "",
        inputA_3: "",
        inputA_4: "",
        inputA_5: "",
        inputA_6: "",

        inputB_1: "",
        inputB_1_1: "",
        inputB_2: "",
        inputB_3: "",
        inputB_4: "",
        inputB_5: "",
        inputB_6: "",

        inputC_1: "",
        inputC_3: "",
        inputC_4: "",
        inputC_6: "",
        inputC_7: "",
        inputC_8: "",
        inputC_9: "",
        inputC_10: "",
        inputC_11: "",
        inputC_12: "",
        inputC_13: "",
        inputC_14: "",
        inputC_15: "",
        inputC_16: "",
        inputC_17: "",
        inputC_18: "",
        inputC_19: "",

        inputD_1: "",
        inputD_2: "",
        inputD_3: "",
        inputD_4: "",
        inputD_5: "",
        inputD_6: "",
        inputD_7: "",

        inputE_1: "",
        inputE_2: "",
        inputE_3: "",
        inputE_4: "",
        inputE_5: "",
        inputE_6: "",
        list: [],
        fileList: [],
      },
      checkboxSelected: [],
    };
  },
  computed: {
    typeCheckBox() {
      return [
        {
          id: "label_1",
          label: "사내수급인 소속인 경우(건설업 제외)",
          dataTable: [
            {
              text: "원도급인 사업장명",
              index: 1,
              type: "text",
            },
            {
              text: "사업장 산재관리번호(사업개시번호)",
              index: 2,
              type: "text",
            },
          ],
        },
        {
          id: "label_2",
          label: "파견근로자인 경우",
          dataTable: [
            {
              text: "파견사업주 사업장명",
              index: 1,
              type: "text",
            },
            {
              text: "사업장 산재관리번호(사업개시번호)",
              index: 2,
              type: "text",
            },
          ],
        },
        {
          id: "label_3",
          label: "건설업만 작성",
          dataTable: [
            {
              text: "발주자",
              index: 1,
              type: "text",
            },
            {
              text: "세부영역",
              index: 2,
              type: "select",
            },
            {
              text: "원수급 사업장명",
              index: 3,
              type: "text",
            },
            {
              text: "원수급 사업장 산재관리번호(사업개시번호)",
              index: 4,
              type: "text",
            },
            {
              text: "공사현장명",
              index: 5,
              type: "text",
            },
            {
              text: "공사종류",
              index: 6,
              type: "text",
            },
            {
              text: "공정률",
              index: 7,
              type: "text",
              afterText: "%",
            },
            {
              text: "공사금액",
              index: 8,
              type: "text",
              afterText: "백만원",
            },
          ],
        },
      ];
    },
  },
  created() {
    this.checkMobile();
    window.addEventListener("resize", this.checkMobile);

    const keys = Object.keys(this.form);
    for (const key of keys) {
      if (this.value[key]) {
        this.form[key] = this.value[key];
      }
    }
  },
  methods: {
    onClickWM() {
      this.methodActive = !this.methodActive;
    },
    translationMap() {
      const prefix = "(중대)산업재해 발생 보고.산업재해조사표";
      const translateData = {
        [`${prefix}.기본정보.회사명`]: this.form.stdInfo.field_name,
        [`${prefix}.기본정보.작성자이름`]: this.form.stdInfo.writer_name,
        [`${prefix}.기본정보.작성일`]: this.form.stdInfo.date,

        [`${prefix}.사업장명 정보.사업장명`]: this.form.inputB_1,
        [`${prefix}.사업장명 정보.산재관리번호(사업개시번호)`]: this.form.inputB_2,
        [`${prefix}.사업장명 정보.사업자등록번호`]: this.form.inputB_3,
        [`${prefix}.사업장명 정보.근로자 수(명)`]: this.form.inputB_4,
        [`${prefix}.사업장명 정보.업종`]: this.form.inputB_5,
        [`${prefix}.사업장명 정보.소재지`]: this.form.inputB_6,

        [`${prefix}.재해정보.성명`]: this.form.inputC_1,
        [`${prefix}.재해정보.주민등록번호(외국인등록번호)`]: this.form.inputC_2,
        [`${prefix}.재해정보.직업`]: this.form.inputC_4,

        [`${prefix}.재해정보.같은 종류업무 근속기간.년`]: this.form.inputC_10,
        [`${prefix}.재해정보.같은 종류업무 근속기간.월`]: this.form.inputC_11,
        [`${prefix}.재해정보.고용형태`]: this.form.inputC_12,
        [`${prefix}.재해정보.근무형태`]: this.form.inputC_14,
        [`${prefix}.재해정보.상해종류(질병명)`]: this.form.inputC_16,
        [`${prefix}.재해정보.상해부위(질병부위)`]: this.form.inputC_17,
        [`${prefix}.재해정보.휴업예상 일수`]: this.form.inputC_18,
        [`${prefix}.재해정보.사망 여부`]: this.form.inputC_19,
        [`${prefix}.재해정보.주소`]: this.form.enc.inputC_20,

        [`${prefix}.재해발생 개요 및 원인.발생날짜`]: this.form.inputD_1,
        [`${prefix}.재해발생 개요 및 원인.발생시간`]: this.form.inputD_2,
        [`${prefix}.재해발생 개요 및 원인.발생장소`]: this.form.inputD_3,
        [`${prefix}.재해발생 개요 및 원인.재해형태(필수)`]: this.form.inputD_5,
        [`${prefix}.재해발생 개요 및 원인.재해관련 작업유형`]: this.form.inputD_4,
        [`${prefix}.재해발생 개요 및 원인.재해발생 당시상황`]: this.form.inputD_6,
        [`${prefix}.재해발생 개요 및 원인.재해발생 원인`]: this.form.inputD_7,

        [`${prefix}.재발방지계획.계획내용`]: this.form.inputE_1,
        [`${prefix}.재발방지계획.즉시 기술지원 서비스 요청`]: this.form.inputE_2,
        [`${prefix}.재발방지계획.사업주`]: this.form.inputE_3,
        [`${prefix}.재발방지계획.근로자대표(재해자)`]: this.form.inputE_4,
        [`${prefix}.재발방지계획.산재보험급여 신청방법 안내를 위한 재해자의 개인정보 활용 동의`]: this.form.inputE_5,
        [`${prefix}.재발방지계획.지방고용노동청장`]: this.form.inputE_6,
      };
      return translateData;
    },
    translate(translate) {
      const prefix = "(중대)산업재해 발생 보고.산업재해조사표";

      this.form.stdInfo.field_name = translate[`${prefix}.기본정보.회사명`];
      this.form.stdInfo.writer_name = translate[`${prefix}.기본정보.작성자이름`];
      this.form.stdInfo.date = translate[`${prefix}.기본정보.작성일`];
      this.form.inputB_1 = translate[`${prefix}.사업장명 정보.사업장명`];
      this.form.inputB_2 = translate[`${prefix}.사업장명 정보.산재관리번호(사업개시번호)`];
      this.form.inputB_3 = translate[`${prefix}.사업장명 정보.사업자등록번호`];
      this.form.inputB_4 = translate[`${prefix}.사업장명 정보.근로자 수(명)`];
      this.form.inputB_5 = translate[`${prefix}.사업장명 정보.업종`];
      this.form.inputB_6 = translate[`${prefix}.사업장명 정보.소재지`];
      this.form.inputC_1 = translate[`${prefix}.재해정보.성명`];
      this.form.inputC_2 = translate[`${prefix}.재해정보.주민등록번호(외국인등록번호)`];
      this.form.inputC_4 = translate[`${prefix}.재해정보.직업`];
      this.form.inputC_10 = translate[`${prefix}.재해정보.같은 종류업무 근속기간.년`];
      this.form.inputC_11 = translate[`${prefix}.재해정보.같은 종류업무 근속기간.월`];
      this.form.inputC_12 = translate[`${prefix}.재해정보.고용형태`];
      this.form.inputC_14 = translate[`${prefix}.재해정보.근무형태`];
      this.form.inputC_16 = translate[`${prefix}.재해정보.상해종류(질병명)`];
      this.form.inputC_17 = translate[`${prefix}.재해정보.상해부위(질병부위)`];
      this.form.inputC_18 = translate[`${prefix}.재해정보.휴업예상 일수`];
      this.form.inputC_19 = translate[`${prefix}.재해정보.사망 여부`];
      this.form.enc.inputC_20 = translate[`${prefix}.재해정보.주소`];
      this.form.inputD_1 = translate[`${prefix}.재해발생 개요 및 원인.발생날짜`];
      this.form.inputD_2 = translate[`${prefix}.재해발생 개요 및 원인.발생시간`];
      this.form.inputD_3 = translate[`${prefix}.재해발생 개요 및 원인.발생장소`];
      this.form.inputD_4 = translate[`${prefix}.재해발생 개요 및 원인.재해관련 작업유형`];
      this.form.inputD_5 = translate[`${prefix}.재해발생 개요 및 원인.재해형태(필수)`];
      this.form.inputD_6 = translate[`${prefix}.재해발생 개요 및 원인.재해발생 당시상황`];
      this.form.inputD_7 = translate[`${prefix}.재해발생 개요 및 원인.재해발생 원인`];
      this.form.inputE_1 = translate[`${prefix}.재발방지계획.계획내용`];
      this.form.inputE_2 = translate[`${prefix}.재발방지계획.즉시 기술지원 서비스 요청`];
      this.form.inputE_3 = translate[`${prefix}.재발방지계획.사업주`];
      this.form.inputE_4 = translate[`${prefix}.재발방지계획.근로자대표(재해자)`];
      this.form.inputE_5 = translate[`${prefix}.재발방지계획.산재보험급여 신청방법 안내를 위한 재해자의 개인정보 활용 동의`];
      this.form.inputE_6 = translate[`${prefix}.재발방지계획.지방고용노동청장`];
    },
    checkMobile() {
      this.isMobile = window.innerWidth < 768;
    },

    onComapnySelect(data) {
      this.form.inputB_1_1 = data.com_name;
      this.form.inputB_3 = data.com_number;
      this.form.inputB_5 = data.com_business_type;
      this.form.inputB_6 = data.com_address;
    },
    onCheck(value) {
      this.form.employmentType = [value[value.length - 1]];
      const _employmentTypeId = this.form.employmentType[0];
      if (_employmentTypeId) {
        this.form.employmentTypeLabel = this.typeCheckBox.filter((x) => x.id === _employmentTypeId)[0].label;
        const objSelected = this.typeCheckBox.filter((x) => x.id === _employmentTypeId)[0];
        this.checkboxSelected = objSelected;
        const temp = [];
        objSelected.dataTable.forEach((element) => {
          temp.push({ ...element, value: "" });
        });
        this.form.list = temp;
      } else {
        this.checkboxSelected = {};
        this.form.list = [];
      }
    },

    validate() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        // 검증
      }
    },
  },
};
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}
.mt-component-form {
  margin-top: 15px;
}

/* uploaded File */
.h-upload {
  height: 470px;
}
.upload-content {
  border: $border;
  &:last-child {
    border-left: none;
  }
  &__title {
    height: 54px;
    line-height: 54px;
    text-align: center;
    background: #fafafa;
    border-bottom: $border;
  }
  &__input {
    height: 54px;
    background: #f9f9f9;
    border-top: $border;
    padding: 5px 15px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &__file {
    height: calc(100% - 54px);
    width: 100%;
    padding: 14px;
  }
}

table.table-1 {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;

  th {
    border-top: 1px solid #cdcdcd;
    border-bottom: 1px solid #cdcdcd;
    background: #f0f0f0;
    padding: 6px;
    font-weight: 400;
  }

  tr {
    &:first-of-type td {
      border-top: 1px solid #cdcdcd;
    }
    td {
      border-bottom: 1px solid #cdcdcd;
      padding: 4px;
      word-break: keep-all;
    }
  }

  &.table-1-mb tr:nth-child(2n) td {
    border-bottom: none;
  }
}

table.table-2 {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;

  th {
    border: 1px solid #cdcdcd;
    background: #f0f0f0;
    padding: 8px;
    font-weight: 500;
    font-size: 14px;
    text-align: center;
  }

  td {
    border: 1px solid #cdcdcd;
    padding: 8px;
    word-break: keep-all;
    font-weight: 400;
    font-size: 14px;
  }
}

.bold {
  font-weight: 500;
}

.process-step {
  display: flex;
  align-items: center;
  justify-content: center;

  .arrow {
    margin: 20px 0;
    padding-bottom: 18px;
    color: #cdcdcd;
  }

  .square {
    display: inline-block;
    width: 200px;
    height: 30px;
    border: 1px solid #cdcdcd;
    text-align: center;
    align-content: center;
    font-size: 14px;
  }
}
</style>
